<template>
  <div id="p">
    <div style="flex: 1"></div>
    <div id="app">
      <el-container>
        <el-header height="150px">
          <HeaderContent/>
        </el-header>
        <el-main>
          <TabContent />
        </el-main>
        <el-footer>
          Sebastian's Lab
        </el-footer>
      </el-container>
    </div>
    <div style="flex: 1"></div>
  </div>
</template>

<script>
  import TabContent from './components/TabContent'
  import HeaderContent from './components/HeaderContent'

  export default {
    name: 'app',
    components: {
      TabContent,
      HeaderContent
    }
  }
</script>

<style>
  #p{
    flex-direction: row;
    background-color: #f0f0f0;
    height: auto;
    min-height: 100%;
    display: flex;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    max-width: 1200px;
    min-width: 800px;
    background-color: white;
    flex: 4;
  }
  .el-header, .el-footer {
    padding: 0
  }

  .el-main {
    background-color: white;
    /*background-color: #F8F8F8;*/
    /*color: #333;*/
    min-height: 700px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue